import React from 'react';

import {
  Paper,
  Typography,
} from '@material-ui/core';

import ActivityProfile from './ActivityProfile';
import ActivityAction from './ActivityAction';
import ActivityTerms from './ActivityTerms';
import ActivityExtraData from './ActivityExtraData';

import classes from '../../css/getCSS';


const activityItem = (props) => {
  let title = '';
  if (props.type === 'shortlists') {
    title += 'Shortlisted - ';
  }
  if (props.type === 'interests' && props.item.activity_type === 'sent') {
    title += 'Interest Sent - ';
  }
  if (props.type === 'interests' && props.item.activity_type === 'received') {
    title += 'Interest Received - ';
  }
  if (props.type === 'requests' && props.item.activity_type === 'sent') {
    title += 'Request Sent - ';
  }
  if (props.type === 'requests' && props.item.activity_type === 'received') {
    title += 'Request Received - ';
  }
  if (props.type === 'recommendations') {
    title += 'Recommendation Received - ';
  }
  title += `${props.item.target_user.first_name}`;
  title += ` ${props.item.target_user.last_name}`;

  return (
    <Paper className={[classes.card, classes.padding20].join(' ')}>
      <Typography variant="headline">{title}</Typography>
      <Typography variant="body1">{props.item.created_at}</Typography>
      <br />
      <ActivityExtraData {...props} />
      <ActivityAction {...props} />
      <ActivityTerms {...props} />
      <ActivityProfile {...props} />
    </Paper>
  );
};

export default activityItem;



// WEBPACK FOOTER //
// ./src/activities/components/ActivityPageItem.js